import styled from 'styled-components';
import {Space} from 'antd';

const StyledUserMultiSelectWrapper = styled(Space)`
  display: flex;
  flex-direction: column;
  width: 100%;

  .ant-select-multiple.ant-select-lg {
    .ant-select-selection-overflow {
      position: relative;
    }

    .ant-select-selection-overflow-item {
      position: absolute;
    }
  }

  .ant-select-selection-overflow-item-rest + .ant-select-selection-overflow-item-suffix {
    margin-left: 8px;
  }

  .ant-select-selection-overflow-item-rest {
    display: none;
  }
`;

const StyledUserMultiSelectSelectedList = styled(Space)`
  width: 100%;

  & > .ant-space-item {
    display: flex;
    width: 100%;
  }
`;

const StyledUserMultiSelectSelectedItem = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const StyledUserMultiSelectSelectedItemLabel = styled.span`
  margin-right: 4px;
`;

const StyledUserMultiSelectPlaceholder = styled.span`
  color: rgba(0,0,0,0.25);
  padding: 0 8px;
`;

export {
  StyledUserMultiSelectPlaceholder,
  StyledUserMultiSelectWrapper,
  StyledUserMultiSelectSelectedList,
  StyledUserMultiSelectSelectedItem,
  StyledUserMultiSelectSelectedItemLabel,
}

